import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../constants/apiConstants";
import { iThunkApi } from "../../types/commonTypes";
import {
	IGetAiMenuAndServicesInfoData,
	IGetPreviousQuotesParams,
	IGetPreviousQuotesResponseData,
	ISubmitMenuExtractionPromptResponse,
	IUploadFileToOpenAIBody,
	IUploadFileToOpenAIResponse,
} from "../../types/quoteFormTypes";
import { API_METHOD_TYPE, apiManager, isApiSuccess } from "../apiManager";

export const uploadFileToOpenAIThunk = createAsyncThunk<IUploadFileToOpenAIResponse, IUploadFileToOpenAIBody, iThunkApi>(
	"quote/upload-file-to-open-ai",
	async (body, thunkAPI) => {
		const resp = await apiManager(API_ENDPOINTS.UPLOAD_FILE_TO_OPEN_AI, body, API_METHOD_TYPE.POST, {});
		if (!resp || !isApiSuccess(resp?.status)) {
			return thunkAPI.rejectWithValue(resp?.data);
		}
		return resp?.data?.data;
	},
);

export const submitMenuExtractionPromptThunk = createAsyncThunk<ISubmitMenuExtractionPromptResponse, string, iThunkApi>(
	"quote/submit-menu-extraction-prompt",
	async (fileId, thunkAPI) => {
		const resp = await apiManager(
			API_ENDPOINTS.SUBMIT_MENU_EXTRACTION_PROMPT,
			{ fileId },
			API_METHOD_TYPE.POST,
			{},
		);
		if (!resp || !isApiSuccess(resp?.status)) {
			return thunkAPI.rejectWithValue(resp?.data);
		}
		return resp?.data?.data;
	},
);

export const getAiMenuAndServicesInfoThunk = createAsyncThunk<
	IGetAiMenuAndServicesInfoData,
	string,
	iThunkApi
>("quote/get-ai-menu-and-services-info", async (menuExtractionPromptId, thunkAPI) => {
	const resp = await apiManager(
		API_ENDPOINTS.GET_AI_MENU_AND_SERVICES_INFO(menuExtractionPromptId),
		null,
		API_METHOD_TYPE.GET,
		{},
	);
	if (!resp || !isApiSuccess(resp?.status)) {
		return thunkAPI.rejectWithValue(resp?.data);
	}
	return resp?.data?.data;
});

export const getPreviousQuotesThunk = createAsyncThunk<IGetPreviousQuotesResponseData, IGetPreviousQuotesParams, iThunkApi>(
	"quote/get-previous-quotes",
	async (params, thunkAPI) => {
		const resp = await apiManager(
			API_ENDPOINTS.GET_PREVIOUS_QUOTES(params),
			null,
			API_METHOD_TYPE.GET,
			{},
		);
		if (!resp || !isApiSuccess(resp?.status)) {
			return thunkAPI.rejectWithValue(resp?.data);
		}
		return resp?.data?.data;
	},
);
